import { SALES_CLOSED_STATUS } from '../constants';

export const isOfferSalesClosed = offer => offer?.status === SALES_CLOSED_STATUS;
